import VueCqrs from '@cqrs/vue-component-cqrs';
import * as c from '@Quest/Financials/Capex/Domain/commands-core';
import { Component } from 'vue-facing-decorator';

@Component
export default class CapexCommands extends VueCqrs {

	invokeCreateCapexAccountCommandV1(workspaceId: number, strategyId: string, capexId: string, name: string, description: string, classification: string)
	{
		const cmd = new c.CreateCapexAccountCommandV1(workspaceId, strategyId, capexId, name, description, classification);
		this.$command(cmd, capexId);
	}

	invokeDeleteCapexAccountCommandV1(workspaceId: number, strategyId: string, capexId: string)
	{
		const cmd = new c.DeleteCapexAccountCommandV1(workspaceId, strategyId, capexId);
		this.$command(cmd, capexId);
	}

	invokeUpdateCapexAccountCommandV1(workspaceId: number, strategyId: string, capexId: string, name: string, description: string, classification: string)
	{
		const cmd = new c.UpdateCapexAccountCommandV1(workspaceId, strategyId, capexId, name, description, classification);
		this.$command(cmd, capexId);
	}
}
